<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">会务手册，准备中。。。</div>
        <div class="letterTitle">2020/4/12    23:00</div>
        <div class="twodiv">
          会务手册，准备中。。。
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'ProductCiaabian',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {
    padding: 74px 100px 50px 100px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 40px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    height: 320px;
    width: 700px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Product-Manual.vue